import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import withNotifications from '../../../../../common/withNotifications';
import { getIsRentalShop } from '../../../../../auth/selectors';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { canUseCommissionReporting, canUserViewBankAccounts } from '../../../../../common/helpers/users';
import { AUTO_PAYOUT_ELIGIBILITY_COMMISSION_SPLIT_URL } from '../../../../../common/KnowledgeArticleLink/constants';

export default compose(
  withRouter,
  withNotifications,
  withPermissions,
  connect((state, ownProps) => ({
    isRentalShop: getIsRentalShop(state),
    hasPermissionsToViewCommissionSplits: canUserViewBankAccounts(ownProps.permissions),
    hasConfigurationToViewCommissionSplits: canUseCommissionReporting(state),
  })),
  withProps(() => ({
    name: 'Commission Splits',
    description: 'Configure how your barbers split service, product sales, and tips, with the shop.',
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_COMMISSION_SPLIT_URL,
    eligibilityActionDescription: 'Go to Commission Splits',
  })),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      let canPerformAction = true;

      if (props.isRentalShop) {
        props.addNotification({
          title: 'Error',
          level: 'error',
          message: 'You do not have any commission barbers on your staff to use Auto Payout.',
        });

        canPerformAction = false;
      }

      if (!props.hasPermissionsToViewCommissionSplits) {
        props.addNotification({
          title: 'Error',
          level: 'error',
          message: 'You do not have required permissions.\n'
            + 'Please contact a staff manager to update this permission for you.',
        });

        canPerformAction = false;
      }

      if (!props.hasConfigurationToViewCommissionSplits) {
        props.addNotification({
          title: 'Error',
          level: 'error',
          message: 'You are missing a configuration.\n'
            + 'Please contact SQUIRE Support to update this for you.',
        });

        canPerformAction = false;
      }

      if (!canPerformAction) {
        return;
      }

      props.router.push('/settings/commission');
    },
  })),
)(AutoPayoutEligibilityStep);
